import { generateUUID } from 'store/functions/geoJsonFunctions.js';
import { getValueAt, addCoordsToTrip } from 'store/functions/inputFunctions';
import { validateTable } from 'store/reducers/helpers/validateRow.js';
import { reconcileTravelCostTyping } from 'store/functions/travelCostTyping.js';


//this is a helper function for when decipherUploadedTravelCosts returns.
export const decipherUploadedTravelCostsReturnHelper = (state, response) => {

  const travelCosts = response.TravelCostResponses
  const notifications = response.UploadedTravelCostNotifications;
  /*
  The vehicle types these rows may name. The response's own NewVehicleTypes are
  included because they are added to the table AFTER this helper runs
  (decipherTravelCostsAfterWarning) — without them a row naming a type the
  upload introduced could never be linked to it.
  */
  const knownVehicleTypes = [
    ...(state['data']['vehicle_types'] || []),
    ...((response.NewVehicleTypes || []).map((vt) => ({
      UUID: vt.vehicleTypeId,
      vehicleType: vt.vehicleType,
    }))),
  ];
  state['data']['travel_costs'] = travelCosts.map((cost) => {
    const newCost = {
      'UUID': generateUUID(),
      'fromLocationName': cost.fromLocationName,
      'toLocationName': cost.toLocationName,
      'fromLocationId': cost.fromLocationId,
      'toLocationId': cost.toLocationId,
      'vehicleType': cost.vehicleType,
      // Carried through, not dropped. This key was simply missing from the
      // object literal, so every upload stripped the vehicle type ids off the
      // whole matrix; adding one stop afterwards then wrote typed rows beside
      // untyped ones and the solve quietly dropped stops. Rows that carry only
      // the name are relinked below, against the types this scenario has.
      'vehicleTypeId': cost.vehicleTypeId ?? null,
      'distance': cost.distance,
      'duration': cost.duration,
      'cost': cost.cost,
      'Valid': true,
      'validationMessage': ''
    };
    return newCost;
  });

  reconcileTravelCostTyping(state, { notify: true, vehicleTypes: knownVehicleTypes });

  notifications.forEach((notification) => {
    const newNotification = {
      'message': notification.message,
      'type': notification.type
    }
    state['notifications']['routine'].push(newNotification)
  })
  
  state = validateTable(state, 'travel_costs')
  return state
}

/**
 * Checks to see if newRow has a fromLocationId and toLocationId. If not, it attempts to find
 * the UUIDs from the locations table
 * @param {*} newRow a new trips row
 * @param {object} locations an array of JSON table elements
 */
export const checkTripUuids = (newRow, locations) => {
  let retNewRow = {...newRow};
  let changed = false;
  if (!newRow['fromLocationId']) {
    const fromLoc = newRow['fromLocationName'];
    if (fromLoc) {
      const fromResponse = getValueAt(locations, null, ['locationName'], [fromLoc],'UUID')
      if (fromResponse && fromResponse.exists) {
        retNewRow['fromLocationId'] = fromResponse.value;
        changed = true;
      }
    }
  } 
  if (!newRow['toLocationId']) {
    const toLoc = newRow['toLocationName'];
    if (toLoc) {
      const fromResponse = getValueAt(locations, null, ['locationName'], [toLoc],'UUID')
      if (fromResponse && fromResponse.exists) {
        retNewRow['toLocationId'] = fromResponse.value;
        changed = true;
      }
    }
  } 
  if (changed) {
    retNewRow = addCoordsToTrip(locations, retNewRow);
  }
  return retNewRow;
}
